import { Box } from '@mui/material';
import { AlertSnackbar, useOnlineStatus } from '@shared';

export const OfflineCover = () => {
  const isOnline = useOnlineStatus();
  return (
    <>
      <Box
        sx={({ palette }) => ({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: palette.grey[500],
          opacity: 0.5,
          visibility: isOnline ? 'hidden' : 'visible',
        })}
      />
      <AlertSnackbar
        open={!isOnline}
        title='No Internet connection'
        text='Please, check your internet connection'
        isCenter
      />
    </>
  );
};
